import React, { useEffect, useState } from 'react';
import { MyModal } from '../my-modal';

interface CustomModalProps {
  openButton: JSX.Element;
  title?: string;
  children?: JSX.Element;
  footer?: JSX.Element;
  size?: string;
  isClosed?: boolean;
  open?: () => void;
}

const CustomModal = ({
  openButton,
  title,
  children,
  footer,
  isClosed,
  open,
}: CustomModalProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = (e: React.MouseEvent) => {
    e.stopPropagation();
    e.preventDefault();
    setIsOpen(true);
    open && open();
  };

  useEffect(() => {
    if (isClosed) {
      setIsOpen(false);
    }
  }, [isClosed]);

  return (
    <>
      {React.cloneElement(openButton, { onClick: openModal })}
      <MyModal isOpen={isOpen} onClose={() => setIsOpen(false)}>
        {title && <h2 className="text-xl font-semibold mb-4">{title}</h2>}
        <div>{children}</div>
        {footer && <div className="mt-4">{footer}</div>}
      </MyModal>
    </>
  );
};

export default CustomModal;
